module.exports = __webpack_public_path__ + "img/infos.21d28582.svg";